import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, CanMatchFn } from '@angular/router';
import { UserState } from '@shared/states/user.state';
import { AuthoritiesCondition, Authority } from '@shared/types/authority';

export const AuthoritiesCanActivateGuard: CanActivateFn = (route) => {
  return hasAuthorities(
    route.data?.authorities as Authority[],
    route.data?.authoritiesCondition as AuthoritiesCondition,
  );
};

export const AuthoritiesCanActivateChildGuard: CanActivateChildFn = (route) => {
  return hasAuthorities(
    route.data?.authorities as Authority[],
    route.data?.authoritiesCondition as AuthoritiesCondition,
  );
};

export const AuthoritiesCanMatchGuard: CanMatchFn = (route) => {
  return hasAuthorities(
    route.data?.authorities as Authority[],
    route.data?.authoritiesCondition as AuthoritiesCondition,
  );
};

function hasAuthorities(
  authorities: Authority[],
  condition: AuthoritiesCondition = 'all',
): boolean {
  if (authorities?.length) {
    return inject(UserState).hasAuthorities(authorities, condition);
  }

  return true;
}
